import {
  handleCatchErrors,
  responseDataFormat,
  responseDataFormatReduxAuth,
} from "../../middlewares/resolveRequests";
import { getCommunitiesDataWithPermssions } from "../../services/admin/comunityCRUD";
import {
  addRolesCommunityMembers,
  getAllCommunities,
  getCommunity,
  getCommunityCounts,
  getCommunityMembers,
  getCommunityRoles,
} from "../../services/community";
import * as actionTypes from "../actions/actionTypes";

export const getCommunities = async (pageNumber = 1, pageSize = 2, token) => {
  let response;
  try {
    response = await getAllCommunities(pageNumber, pageSize, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
export const getCommunitiesWithPermssions = async (
  pageNumber = 1,
  pageSize = 2,
  token
) => {
  let response;
  try {
    response = await getCommunitiesDataWithPermssions(
      pageNumber,
      pageSize,
      token
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const currentCommunity = async (communityId) => {
  let response = {
    data: {
      status: 200,
      data: communityId,
    },
  };
  return responseDataFormatReduxAuth(response, actionTypes.COMMUNITY);
};

export async function getCommunityDetails(communityId, token) {
  let response;
  try {
    response = await getCommunity(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export function clearCommunityDetails() {
  let status = 200;
  let response = {
    data: status >= 200 && status <= 206 ? true : false,
  };
  return responseDataFormat(response);
}

export async function getCommunityLength(communityId, token) {
  let response;
  try {
    response = await getCommunityCounts(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export async function communityRoles(token) {
  let response;
  try {
    response = await getCommunityRoles(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export async function communityMembers(roleId, communityId, token) {
  let response;
  try {
    response = await getCommunityMembers(roleId, communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export async function addRoleToCommunityMembers(
  roleId,
  communityId,
  body,
  token
) {
  let response;
  try {
    response = await addRolesCommunityMembers(roleId, communityId, body, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}
